module.exports = __webpack_public_path__ + "img/Logout-icon.4f35d9d4.svg";